import React from 'react'
import { Routes, Route } from 'react-router-dom'
import PrivateRoutes from './PrivateRoutes'
import ScrollToHash from 'components/ScrollToHash'
import DashboardPage from 'pages/Dashboard'
import AccountManagementPage from 'pages/AccountManagement'
import AccountDetailPage from 'pages/AccountDetail'
import ProductsPage from 'pages/Products'
import OrdersPage from 'pages/Orders'
import TasksPage from 'pages/Tasks'
import AdminManagementPage from 'pages/AdminManagement'
import LoginPage from 'pages/Login'
import ResetPasswordPage from 'pages/ResetPassword'
import NotFoundPage from 'pages/NotFound'
import NotificationSettingsPage from 'pages/NotificationSettings'

const AppRoutes = () => {
  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path='/' element={<DashboardPage />} />
          <Route path='/accounts' element={<AccountManagementPage />} />
          <Route path='/accounts/:accountId' element={<AccountDetailPage />} />
          <Route path='/products' element={<ProductsPage />} />
          <Route path='/tasks' element={<TasksPage />} />
          <Route path='/orders' element={<OrdersPage />} />
          <Route
            path='/notification-settings'
            element={<NotificationSettingsPage />}
          />
          <Route path='/admin-management' element={<AdminManagementPage />} />
        </Route>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/password-reset' element={<ResetPasswordPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </>
  )
}

export default AppRoutes
